export function getParagraphIndentLevel(paragraph: HTMLDivElement): number {
  const { marginLeft } = paragraph.style;
  if (!marginLeft) {
    return 0;
  }

  const match = marginLeft.match(/^\s*(\d+)em\s*$/i);
  if (!match) {
    return 0;
  }

  const number = parseInt(match[1], 10);
  return Math.max(0, Math.round(number));
}

export function setParagraphIndentLevel(paragraph: HTMLDivElement, level: number) {
  if (level <= 0) {
    // eslint-disable-next-line no-param-reassign
    paragraph.style.marginLeft = '';

    if (paragraph.getAttribute('style') === '') {
      paragraph.removeAttribute('style');
    }
    return;
  }

  // eslint-disable-next-line no-param-reassign
  paragraph.style.marginLeft = `${level}em`;
}

export function indentParagraph(paragraph: HTMLDivElement) {
  setParagraphIndentLevel(paragraph, getParagraphIndentLevel(paragraph) + 1);
}

export function outdentParagraph(paragraph: HTMLDivElement) {
  setParagraphIndentLevel(paragraph, getParagraphIndentLevel(paragraph) - 1);
}
